type GridSizeFn = (
  tilesLength: number,
  index: number,
) => { rows: number; cols: number };

export const getGridSize: GridSizeFn = (tilesLength, index) => {
  switch (tilesLength) {
    case 3:
      return { rows: 1, cols: index === 2 ? 2 : 1 };
    case 2:
      return { rows: 1, cols: 2 };
    case 1:
      return { rows: 2, cols: 2 };
    default:
      return { rows: 1, cols: 1 };
  }
};
